import { render, staticRenderFns } from "./InspectionTaskDetailSkeleton.vue?vue&type=template&id=036d7f54&scoped=true"
import script from "./InspectionTaskDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./InspectionTaskDetailSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d7f54",
  null
  
)

export default component.exports